

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Policy from "./pages/Policy";
import "./i18n";
import About from "./pages/About";

function App() {
  return (
    <div >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/policy/:policyType" element={<Policy />} />
            <Route path="/about" element={<About />} />
          </Route>


        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default App;
